import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { appointmentOutputArtifactTypeSchema } from '@eluve/graphql-types';

const c = initContract();

const createAppointmentOutputArtifactRequestSchema = z.object({
  type: appointmentOutputArtifactTypeSchema,
});

export type CreateAppointmentOutputArtifactRequest = z.infer<
  typeof createAppointmentOutputArtifactRequestSchema
>;

const createAppointmentOutputArtifactResponseSchema = z.object({
  id: z.string(),
  content: z.object({ insights: z.string().nullable() }),
});

export const appointmentOutputArtifactsContract = c.router(
  {
    createAppointmentOutputArtifact: {
      method: 'POST',
      path: '',
      body: createAppointmentOutputArtifactRequestSchema,
      responses: {
        201: createAppointmentOutputArtifactResponseSchema,
        200: createAppointmentOutputArtifactResponseSchema,
      },
      summary: 'Create an appointment output artifact',
    },
  },
  {
    pathPrefix:
      '/:tenantId/appointments/:appointmentId/appointment-output-artifacts/',
  },
);
